import { render, staticRenderFns } from "./previewOfVoucher.vue?vue&type=template&id=157a05f7&scoped=true&"
import script from "./previewOfVoucher.vue?vue&type=script&lang=js&"
export * from "./previewOfVoucher.vue?vue&type=script&lang=js&"
import style0 from "./previewOfVoucher.vue?vue&type=style&index=0&id=157a05f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a05f7",
  null
  
)

export default component.exports